import { ButtonEntity } from "../buttonEntity.js";
import { SplashScreenRender } from "./splashScreenRender.js";
export const SPLASHSCREEN_SCENEID = "splash";
export const VOLUMESCREEN_SCENEID = "volume";
export class SplashScreenScene {
    constructor(sceneTrigger, inputSystem, canvasWidth, canvasHeight) {
        this.sceneTrigger = sceneTrigger;
        this.inputSystem = inputSystem;
        this.canvasWidth = canvasWidth;
        this.canvasHeight = canvasHeight;
        this.localEntities = [];
    }
    onEnter(sceneManager) {
        /* Control handlers */
        const handleStartClick = () => {
            // Load volume settings scene
            sceneManager.loadScene(VOLUMESCREEN_SCENEID);
        };
        /* Add continue button */
        const startBtn = new ButtonEntity("Press Here to Start", "transparent", "white", (this.canvasWidth / 2) - 150, (this.canvasHeight / 2) + 120, 300, 60, this.inputSystem, handleStartClick);
        sceneManager.addTransientUIEntity(startBtn);
        this.localEntities.push(startBtn);
        /* Add Background with title image */
        const screenRenderer = new SplashScreenRender(this.canvasWidth, this.canvasHeight);
        sceneManager.addTransientUIEntity(screenRenderer);
        this.localEntities.push(screenRenderer);
    }
    onResume(sceneManager) {
        // Re-add entities
        for (const entity of this.localEntities) {
            sceneManager.addTransientUIEntity(entity);
        }
    }
    onExit() { }
    update(context) { }
    draw(context) { }
}
